export default function Footer() {
  return (
    <footer className="border-t-2 border-black mt-16" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-8 grid grid-cols-1 md:grid-cols-4 gap-6 font-mono-data text-xs uppercase">
        <div>
          <div className="font-brand text-2xl text-black normal-case">marketcraig<span className="text-[#0000EE]">.</span></div>
          <p className="mt-2 text-gray-700 normal-case">a straightforward classifieds board. modern brutalism for buyers & sellers.</p>
        </div>
        <div>
          <h4 className="font-bold mb-3 border-b border-black pb-1">Browse</h4>
          <ul className="space-y-1">
            <li><a href="/category/vehicles" className="link-blue">Vehicles</a></li>
            <li><a href="/category/real-estate" className="link-blue">Real Estate</a></li>
            <li><a href="/category/jobs" className="link-blue">Jobs</a></li>
            <li><a href="/category/electronics" className="link-blue">Electronics</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-3 border-b border-black pb-1">Account</h4>
          <ul className="space-y-1">
            <li><a href="/post" className="link-blue">Post an Ad</a></li>
            <li><a href="/dashboard" className="link-blue">Dashboard</a></li>
            <li><a href="/favorites" className="link-blue">Favorites</a></li>
            <li><a href="/messages" className="link-blue">Messages</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-3 border-b border-black pb-1">About</h4>
          <p className="text-gray-700 normal-case">© {new Date().getFullYear()} marketcraig — built on emergent.</p>
        </div>
      </div>
    </footer>
  );
}
